module.exports = __webpack_public_path__ + "img/cloth_g3_shoe-04.f2d1c67e.svg";